import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import DigitizeImg from "../../images/location_new/fold5/img02.webp";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Link } from "gatsby";

function Digitize(props) {
  return (
    <div className="digitize_sec p-100" style={{ backgroundColor: "#262032" }}>
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>Tech-Enabled App Development Company</h2>
            <p>
              Experience transformative mobile app development in Austin powered
              by novel tech at every step. Our diversely skilled app developers
              get you robust, scalable, and user-centric mobile solutions. With
              agile methodologies and continuous integration, we offer rapid
              deployment and efficient development cycles. Partnering with
              TekRevol means accessing proven expertise to transform your ideas
              into impactful apps.
            </p>
            <p>
              Experience quick integrations, reliable performance, and
              innovative solutions that value users and drive business. With a
              track record of success, TekRevol is your go-to tech-enabled{" "}
              <Link to="/app-development-austin" style={{ color: "#f47a1f" }}>
                app development company in Austin
              </Link>{" "}
              that delivers tangible results and justifies investment from every
              aspect. Got an app idea? Discuss with our app development experts
              on a free first call.
            </p>
            <Link
              style={{
                backgroundColor: "#fff",
                color: "#262032",
                border: "1px solid #262032",
              }}
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Discuss Project Scope
            </Link>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="digitize_img">
            <LazyLoadImage
              src={DigitizeImg}
              effect="blur"
              alt="Image"
              className="img-fluid"
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Digitize;
